module.exports = __webpack_public_path__ + "static/media/splash.d9802e53.jpg";